export default __webpack_public_path__ + "media/images/images/banner/banner-13-7de7dadc190232e3f805d3b784385ca2.jpg";